<div class="modalClose">
  <img src="/assets/img/shared/close.svg" (click)="cancel()" />
</div>

<ion-content [fullscreen]="true">
  <ion-grid>
    <ion-row class="mb-8">
      <ion-col>
        <h2>Se adresse i kart</h2>
        <p class="pt-2">
          Hvis bilen står innenfor en 200 meter radius av lokasjonen, kan den
          aktivere smartlading
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <div class="map-container">
          <app-map [chargingLocation]="chargingLocation"></app-map>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
